<template>
	<div style="min-height: 60vh; max-height: 100%">
		<vx-card :title="null" class="mt-5" no-shadow card-border>
			<div class="vx-row">
				<div class="vx-col w-full flex items-center">
					<feather-icon
						class="g-breadcrumb--title"
						icon="ChevronLeftIcon"
						svgClasses="h-8 w-8"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					/>
					<vs-breadcrumb
						class="g-breadcrumb--title"
						separator=""
						:items="[{title: $t('general.Return')}]"
						@click.prevent="$emit('changeActiveTabEmit', 0)"
					></vs-breadcrumb>
				</div>
			</div>
			<bread-crumbs
				class="ml-1"
				:title="
					editable
						? $t('StatusMobile.FormStatusMobile.UpdateStatusMobile')
						: $t('StatusMobile.FormStatusMobile.CreateStatusMobile')
				"
				:subTitle="
					editable ? $t('general.SubtitleStatusMobileUpdate') : $t('general.SubtitleStatusMobileCreate')
				"
				:sizeTitle="22"
				:lineHeightTitle="27"
				:sizeSubTitle="13"
				:lineHeightSubTitle="16"
			>
			</bread-crumbs>
			<vs-row vs-w="12">
				<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
					<div class="vx-row mb-6">
						<div class="vx-col w-full md:w-1/2 mt-2 mb-2">
							<label class="g-label" v-text="$t('Name')"></label>
							<vs-input
								class="w-full"
								v-model="statusMobile.name"
								name="name"
								v-validate="{required: true, regex: /^[A-Za-z\s_]+$/}"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('name')"
								v-text="$t('StatusMobile.FormStatusMobile.ValidMessages.Name')"
							></span>
						</div>
						<div class="vx-col w-full md:w-1/2 mt-2 mb-2">
							<label class="g-label">{{ $t("Status") }}</label>
							<v-select
								name="status"
								:options="listStatus"
								value="id"
								label="name"
								v-model="statusSelected"
								:getOptionLabel="(user) => user.name"
								v-validate="{required: true}"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
							<span
								class="text-danger text-sm"
								v-show="errors.has('status')"
								v-text="$t('StatusMobile.FormStatusMobile.ValidMessages.Description')"
							></span>
						</div>
						<div class="vx-col w-full md:w-1/2 mt-2 mb-2">
							<label class="g-label" v-text="$t('StatusMobile.ListStatusMobile.Description')"></label>
							<vs-textarea
								class="w-full"
								v-model="statusMobile.description"
								name="description"
								v-validate="{required: true}"
							/>
							<span
								class="text-danger text-sm"
								v-show="errors.has('description')"
								v-text="$t('StatusMobile.FormStatusMobile.ValidMessages.Description')"
							></span>
						</div>
						<div class="vx-col w-full md:w-1/2 mt-2 mb-2">
							<div class="vx-row">
								<div class="vx-col w-full md:w-1/2">
									<vs-tooltip
										color="success"
										position="top"
										:text="$t('StatusMobile.ListStatusMobile.ActiveEventToltip')"
									>
										<label class="g-label">
											{{ $t("StatusMobile.ListStatusMobile.ActiveEvent") }}</label
										>
										<vs-switch
											class="mt-2"
											color="success"
											v-model="statusMobile.active_event"
											vs-icon="done"
										/>
									</vs-tooltip>
								</div>
								<div class="vx-col w-full md:w-1/2">
									<vs-tooltip
										color="success"
										position="top"
										:text="$t('StatusMobile.ListStatusMobile.ZoneRequiredToltip')"
									>
										<label class="g-label">
											{{ $t("StatusMobile.ListStatusMobile.ZoneRequired") }}
										</label>
										<vs-switch
											class="mt-2"
											color="success"
											v-model="statusMobile.zone_required"
											vs-icon="done"
										/>
									</vs-tooltip>
								</div>
							</div>
						</div>
					</div>
				</vs-col>
			</vs-row>
		</vx-card>
		<div class="vx-row mt-16 float-right">
			<div class="vx-col w-full">
				<vs-button
					v-if="editable"
					class="g-btn--resourcePopup"
					type="border"
					color="danger"
					style="padding: 0.7rem 3.8rem"
					@click.prevent="cancelEdit"
					>{{ $t("Cancel") }}
				</vs-button>
				<vs-button
					id="btn-submit-company"
					class="ml-4 g-btn--resourcePopup"
					type="filled"
					color="success"
					style="padding: 0.7rem 3.8rem"
					:disabled="isFormValid"
					@click.prevent="submitForm"
					>{{ $t("Save") }}
				</vs-button>
			</div>
		</div>
	</div>
</template>

<script>
import moduleStatusMobile from "@/store/status-mobile/moduleStatusMobile.js";
import StatusMobile from "@/models/StatusMobile.js";
import vSelect from "vue-select";

export default {
	name: "StatusMobileForm",
	data() {
		return {
			statusSelected: {},
		};
	},
	components: {
		vSelect,
	},
	props: {
		statusMobile: Object,
		editable: Boolean,
	},
	computed: {
		// lista de status
		listStatus() {
			return this.$store.state.moduleStatusMobile.status;
		},
		// lista de empresas
		listCompanies() {
			return this.$store.state.moduleStatusMobile.companies;
		},
		// Valida si el formulario es valido
		isFormValid() {
			if (this.statusSelected == null) {
				this.statusSelected = {};
			}
			return this.errors.any() || !Object.keys(this.statusSelected).length;
		},
	},
	methods: {
		// cargar
		loading() {
			this.$vs.loading();
		},
		// cerrar cargar
		closeLoading() {
			this.$vs.loading.close();
		},
		// consultar un status especifico
		consultOnlyStatus() {
			this.loading();
			this.$store
				.dispatch("moduleStatusMobile/getOnlyStatus", this.statusMobile.status_id)
				.then((res) => {
					this.closeLoading();
					this.statusSelected = {...res.data};
				})
				.catch((err) => {
					this.closeLoading();
					throw new Error(err);
				});
		},
		// cancelar edicion
		cancelEdit() {
			this.$emit("cancelEditEmit");
			this.statusSelected = {};
		},
		// enviar informacion
		submitForm() {
			this.loading();
			// definir si esta editando o creando
			if (!this.editable) {
				this.createStatusMobile(this.statusMobile);
			} else {
				this.updateStatusMobile(this.statusMobile);
			}
		},
		// Crear status mobile
		createStatusMobile(object) {
			this.$store
				.dispatch("moduleStatusMobile/addStatus", object)
				.then((res) => {
					this.closeLoading();
					this.cancelEdit();
					this.$vs.notify({
						color: "success",
						title: this.$t("StatusMobile.FormStatusMobile.Create.Success.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Create.Success.Text"),
					});
					return res;
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra el load
					this.closeLoading();
					// Muestra un mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusMobile.FormStatusMobile.Create.Error.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Create.Error.Text"),
					});
					throw new Error(err);
				});
		},
		// actualizar status mobile
		updateStatusMobile(object) {
			// inserta el id en el objeto para utilizarlo en la url del PUT
			object.id = this.statusMobile.id;
			this.$store
				.dispatch("moduleStatusMobile/updateStatus", object)
				.then((res) => {
					this.closeLoading();
					this.cancelEdit();
					this.$vs.notify({
						color: "success",
						title: this.$t("StatusMobile.FormStatusMobile.Update.Success.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Update.Success.Text"),
					});
					return res;
				})
				.catch((err) => {
					// Respuesta erronea
					// Cierra el load
					this.closeLoading();
					// Muestra un mensaje de error
					this.$vs.notify({
						color: "danger",
						title: this.$t("StatusMobile.FormStatusMobile.Update.Error.Title"),
						text: this.$t("StatusMobile.FormStatusMobile.Update.Error.Text"),
					});
					throw new Error(err);
				});
		},
	},
	created() {
		// Se registra el modulo
		if (!moduleStatusMobile.isRegistered) {
			this.$store.registerModule("moduleStatusMobile", moduleStatusMobile);
			moduleStatusMobile.isRegistered = true;
		}
	},
	mounted() {
		// si esta editando seteamos estatus especifico en el select
		if (this.editable) {
			const foundStatu = this.listStatus.find((statu) => statu.id === this.statusMobile.status_id);
			this.statusSelected = foundStatu;
		}
	},
	watch: {
		statusSelected(object) {
			this.statusMobile.status_id = object.id;
		},
	},
};
</script>

<style></style>
